import(/* webpackMode: "eager" */ "/var/www/html/serviced-apartment-guest/app/layout.tsx");
